// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"91005b6e","455":"3e4b31be","977":"c6164f76"}[chunkId] + ".chunk.js";
};